import Placemark2Icon from './component'

export default Placemark2Icon
